export const LOADER_VISIBILITY_MLS = 3000
